import React from "react";
import { reportClientError } from "../../utils/clientErrorReporter";

class ErrorBoundary extends React.Component {
	state = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		reportClientError({
			type: "react",
			message: error?.message || String(error),
			stack: error?.stack,
			componentStack: errorInfo?.componentStack,
			source: "ErrorBoundary",
		});
	}

	handleReload = () => {
		window.location.reload();
	};

	handleSignOut = () => {
		try {
			this.props.onSignOut?.();
		} catch (error) {
			console.error("Could not sign out after client error", error);
			window.location.assign("/dashboard");
		}
	};

	render() {
		if (!this.state.hasError) return this.props.children;

		return (
			<main
				role="alert"
				style={{
					minHeight: "100vh",
					display: "grid",
					placeItems: "center",
					padding: "24px",
					background: "#f5f7fb",
					boxSizing: "border-box",
				}}
			>
				<section
					style={{
						width: "min(520px, 100%)",
						padding: "32px",
						borderRadius: "8px",
						background: "#fff",
						boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12)",
						textAlign: "center",
					}}
				>
					<h1 style={{ marginTop: 0, color: "#800303" }}>Something went wrong</h1>
					<p>We’re sorry, but the application encountered an unexpected error. Our team has been notified.</p>
					<div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap", marginTop: "24px" }}>
						<button type="button" onClick={this.handleReload} style={buttonStyle}>
							Reload
						</button>
						<button type="button" onClick={this.handleSignOut} style={{ ...buttonStyle, background: "#fff", color: "#0054a6" }}>
							Go Back
						</button>
					</div>
				</section>
			</main>
		);
	}
}

const buttonStyle = {
	border: "2px solid #0054a6",
	borderRadius: "4px",
	background: "#0054a6",
	color: "#fff",
	cursor: "pointer",
	fontSize: "16px",
	fontWeight: 600,
	padding: "10px 20px",
};

export default ErrorBoundary;
